import API from '../../API.redux';
import { endpoints } from '../../../config/endpoints';
import { joinUrlWithRequiredParams } from '../../../utils';

export const defaultFields = {
  index: 'all',
  show: 'id,title,title_visible,description,description_visible,behaviour,behaviour_visible,instructions,instructions_visible,position',
};

export const defaultParams = {
  index: `fields=${defaultFields.index}`,
  show: `fields=${defaultFields.show}`,
};

export const getEndpoint = (which) => endpoints.respondents.sections[which];

export const showSection = ({
  enrollment_id,
  params = defaultParams.index,
  apiArgs = {},
  endpointKey = 'index',
  applicationQuestionnaireToken,
} = {}) => {
  const ENDPOINT = getEndpoint(endpointKey);

  return API(apiArgs)({
    url: joinUrlWithRequiredParams({
      params,
      url: ENDPOINT.url,
      requiredParamsValues: {
        enrollment_id,
        application_questionnaire_token: applicationQuestionnaireToken,
      },
    }),
    method: ENDPOINT.method,
  });
};

export const sectionsAPICurrentSection = ({ ...args }) => showSection({ ...args, endpointKey: 'current_section' });

export const sectionsAPINextSection = ({ ...args }) => showSection({ ...args, endpointKey: 'next_section' });

export const sectionsAPIPreviousSection = ({ ...args }) => showSection({ ...args, endpointKey: 'previous_section' });
